import React, { Component } from 'react';
import PropTypes from 'prop-types';

// argh, this has to be a class component, not a functional component, because it needs a ref!
class Footer extends Component {
  static propTypes = {
    getRef: PropTypes.func.isRequired,
    openLightbox: PropTypes.func.isRequired,
  };

  componentDidMount() {
    // pass a reference to this component to its parent
    this.props.getRef(this.footer, 'footer');
  }

  render() {
    const { openLightbox } = this.props;

    return (
      <div
        className="Footer"
        ref={_ => {
          this.footer = _;
        }}
      >
        <button className="btn-link-style" onClick={() => openLightbox()}>
          <span className="label">About</span>
          <span className="icon icon-info" />
        </button>
      </div>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.jsx